import { render, staticRenderFns } from "./NewClientCallToast.vue?vue&type=template&id=1451a07a&scoped=true&"
import script from "./NewClientCallToast.vue?vue&type=script&lang=js&"
export * from "./NewClientCallToast.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1451a07a",
  null
  
)

export default component.exports